import React from "react"

import { LinkButton } from "~/components"
import { Container, Content } from "./styles"

export default function Banner() {
  // function scrollToPlans() {
  //   const plans = document.querySelector("#plans")
  //   window.scroll({
  //     top: plans.offsetTop,
  //     left: 0,
  //     behavior: "smooth",
  //   })
  // }

  return (
    <Container>
      <Content>
        <h1>SOS Itaú</h1>
        <p>
          Aqui no Itaú a gente acredita em produtos que tragam benefícios reais
          aos nossos clientes. Por isso, criamos o SOS Casa e o SOS Auto: planos
          de serviços emergenciais para sua casa e seu veículo, fáceis de usar e
          totalmente acionados pelo site.
        </p>
        <LinkButton
          href="#plans"
          color="secondary"
          size="full"
          data-gtm-type="click"
          data-gtm-clicktype="button"
          data-gtm-name="selecione o plano"
        >
          Selecione seu plano
        </LinkButton>
      </Content>
    </Container>
  )
}
